const maxGifs = 5;
const gifBaseUrl = 'https://s3-ap-southeast-2.amazonaws.com/codebrewery-digital-assets/mainpress/app/gif/';

/**
 * Get a random GIF from S3
 * @returns {string}
 */
export default function getRandomGif() {
  return `${gifBaseUrl}${Math.floor(Math.random() * maxGifs) + 1}.gif`;
}
